export default __webpack_public_path__ + "static/media/kapLogo-white.39e910d6.svg";